module.exports = __webpack_public_path__ + "img/MVT_2434.a75063b6.jpg";